import XAPPService from 'app/Core/services/XAPPService';
import _ from 'lodash';

export const GET_EMPRESACATEGORIAS = '{EMPRESACATEGORIA APP] GET CATEGORIAS';
export const GET_EMPRESACATEGORIA = '{EMPRESACATEGORIA APP] GET CATEGORIA';
export const GET_TEMPLATE = '{EMPRESACATEGORIA APP] GET TEMPLATE';

export const OPEN_NEW_EMPRESACATEGORIA_DIALOG = '{EMPRESACATEGORIA APP] OPEN NEW CATEGORIA DIALOG';
export const CLOSE_NEW_EMPRESACATEGORIA_DIALOG = '{EMPRESACATEGORIA APP] CLOSE NEW CATEGORIA DIALOG';
export const OPEN_EDIT_EMPRESACATEGORIA_DIALOG = '{EMPRESACATEGORIA APP] OPEN EDIT CATEGORIA DIALOG';
export const CLOSE_EDIT_EMPRESACATEGORIA_DIALOG = '{EMPRESACATEGORIA APP] CLOSE EDIT CATEGORIA DIALOG';

export const EMPRESACATEGORIA_REMOVE = '{EMPRESACATEGORIA APP] CATEGORIA REMOVE';
export const ADD_EMPRESACATEGORIA = '{EMPRESACATEGORIA APP] ADD CATEGORIA';

export const EMPRESACATEGORIA_WARNING = '{EMPRESACATEGORIA APP] CATEGORIA WARNING';
export const EMPRESACATEGORIA_INFO = '{EMPRESACATEGORIA APP] CATEGORIA INFO';
export const EMPRESACATEGORIA_ERROR = '{EMPRESACATEGORIA APP] CATEGORIA ERROR';
export const EMPRESACATEGORIA_SELECIONAR_WARNING = '{EMPRESACATEGORIA APP] CATEGORIA SELECIONAR WARNING';
export const EMPRESACATEGORIA_SELECIONAR_INFO = '{EMPRESACATEGORIA APP] CATEGORIA SELECIONAR INFO';
export const EMPRESACATEGORIA_SELECIONAR_ERROR = '{EMPRESACATEGORIA APP] CATEGORIA SELECIONAR ERROR';

const ListState =
    [
        'idpessoaformulario',
        'idpessoa',
        'idparent',
        'nome',
        'codigo',
        'natureza',
        'tipocategoria',
        'tipocategoriadescricao',
        'tipo',
        'formulario',
        'statusregistro',
        'statusregistrodescricao',
        'usrins',
        'usrupt',
        'datainsdescricao',
        'datauptdescricao',
        'totalrows',
        'paginas',
    ];

const AddState =
    [
        'idparent',
        'formulario',
        'idpessoa',
        'tipo',
    ];

const UpdateState =
    [
        'formulario'
    ];

export function get(_AIDPessoaFormulario, _AParams) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "pessoaformulario.idpessoaformulario", "Operador": "=", "Valor": _AIDPessoaFormulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Categoria", AActions, "spvwempresacategoria", ListState, "SELECIONAR", AConditionsAND, AConditionsOR)

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESACATEGORIA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESACATEGORIA_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function list(_AAction, _AParams, _AFilter = null, _APagina = 1, _ATarget = null, _ACallback = null) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var ATarget = !_.isNull(_ATarget) ? _ATarget : "spvwempresacategoria";

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = _AFilter.OR;
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Categorias", AActions, ATarget, ListState, _AAction, AConditionsAND, AConditionsOR, _APagina)

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) => {
                Promise.all([
                    dispatch({
                        type: GET_EMPRESACATEGORIAS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                        pagina: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].pagina : 1,
                    })
                ]);

                if (!_.isNull(_ACallback)) {
                    _ACallback();
                }
            }
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESACATEGORIA_SELECIONAR_ERROR,
                    payload: error
                });
            });
    };
}

export function openNewDialog() {
    return {
        type: OPEN_NEW_EMPRESACATEGORIA_DIALOG
    }
}

export function closeNewDialog() {
    return {
        type: CLOSE_NEW_EMPRESACATEGORIA_DIALOG
    }
}

export function openEditDialog(data) {
    return {
        type: OPEN_EDIT_EMPRESACATEGORIA_DIALOG,
        data
    }
}

export function closeEditDialog() {
    return {
        type: CLOSE_EDIT_EMPRESACATEGORIA_DIALOG
    }
}

export function save(_AValue, _AParams, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "INSERIR";

        if (_AValue.idpessoaformulario) {
            AAction = "ATUALIZAR";
            AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, UpdateState);

        }
        else {
            _AValue.formulario.codigo = _AValue.formulario.codigopai + '.' + _AValue.formulario.codigo;
            AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulario", AConditionsAND, AConditionsOR, 1, AddState);
        }


        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESACATEGORIA_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback()
                        }
                    })
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESACATEGORIA_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback()
                        }
                    })
                }
            }

            ).catch(error => {
                return dispatch({
                    type: EMPRESACATEGORIA_ERROR,
                    payload: error
                });
            });
    };
}

export function getTemplate() {
    return (dispatch) => {

        XAPPService.XappGetTemplateAction('pessoa', "121")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TEMPLATE,
                        payload: response,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESACATEGORIA_SELECIONAR_ERROR,
                    payload: error
                });
            });;
    }
}

export function acaoRegistro(_AValue, _AParams, _AAction, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", _AAction, "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: EMPRESACATEGORIA_REMOVE
                    })
                ]).then(() => {
                    if (!_.isNull(_ACallback)) {
                        _ACallback()
                    }
                })
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESACATEGORIA_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: GET_EMPRESACATEGORIAS,
        data: null,
        pagina: 1,
    }
}